import PageWrapper from "../components/PageWrapper";
import {Typography} from "@mui/material";

const NoPage = () => {
    return <PageWrapper>
        <Typography sx={{ pt: 4 }}>Your page was not found</Typography>
    </PageWrapper>
}

export default NoPage